import { useContext } from "react";

import { Link } from "react-router-dom";

import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';

import { Gear, BoxArrowRight, PencilSquare } from 'react-bootstrap-icons';

import { AuthContext } from '../../../store/AuthContext';
import { validaExisteOMenu } from './../../../util/FuncoesComuns';
import Entrar from '../../../assets/img/entrar.svg';
import './index.css';
import { Button } from "react-bootstrap";

const MenuDireito = () => {

  const { user, logout } = useContext(AuthContext);

  return (

    <>
      <Nav className="justify-content-end pe-3 header-empregado">
        {
          !user || Object.keys(user).length === 0 ?

          <div className="entrar">
            <Link to={'/login'}>
              <img src={Entrar} alt="Fazer Login" /> Entrar
            </Link>
          </div>

            :

            <NavDropdown aria-modal="true"
              title={`${user && Object.keys(user).length > 0 && user.unidadeSro && user.unidadeSro?.nome ? user?.unidadeSro?.codigoSro.concat(' - ', user.unidadeSro?.nome, '/SE/', user?.unidadeSro.superintendencia.sigla, ' | ', user.nome.toUpperCase(),' | ', user.tipo) : 'UNIDADE NÃO ENCONTRADA'}`}
              id="header-empregado"
            >
              <NavDropdown.Item as={Link} to="/alterar-unidade" className={`${user && user.isTemMenus && validaExisteOMenu(user?.menus, '/alterar-unidade') ? '' : 'text-decoration-line-through disabled-link'}`}><PencilSquare />  Alterar Unidade</NavDropdown.Item>
              <NavDropdown.Item className="text-decoration-line-through" disabled as={Link} to="/configuracao"><Gear />  Configuração</NavDropdown.Item>
              <NavDropdown.Item id="btn-sair" as={Button} onClick={(e) => logout(e)}><BoxArrowRight />  Sair</NavDropdown.Item>
            </NavDropdown>

        }
      </Nav>

    </>

  )
}

export default MenuDireito